<template>
  <div id="page" class="step-form">
    <Header />
    <main class="main">
      <form class="section-form icw-form" method="POST">
        <div class="section-progressbar">
          <div class="container">
            <ul class="bar-step">
              <li
                class="active done"
                :onclick="'window.location.href=\'' + info + '\''"
              >
                ข้อมูลส่วนตัว
              </li>
              <li
                class="active"
                :onclick="'window.location.href=\'' + wealth + '\''"
              >
                การเงิน
              </li>
              <li>สุขภาพ</li>
              <li>ผลประเมิน</li>
            </ul>
            <ul class="bar-list list2" id="progressbar">
              <li
                v-for="(v, i) in ProgressLength"
                :key="i"
                :class="{ active: currentStep >= v }"
              ></li>
            </ul>
          </div>
        </div>
        <div class="section-fieldset">
          <div class="section-fieldset-wrapper">
            <div class="section-fieldset-inner">
              <div class="container">
                <div class="fieldset-group">
                  <Q1 :QuestionType="'ChildParent'" />
                  <!-- Child And Parent -->
                  <Q2 :QuestionType="'Expenses'" />
                  <!-- Expenses -->
                  <Q3 :QuestionType="'MoneyHealth1'" />
                  <!-- Money Health 1 -->
                  <!-- Check Step2-Q10 -->
                  <Q4 :QuestionType="'MoneyHealth2'" />
                  <!-- Money Health 2 -->
                  <Q5 :QuestionType="'MoneyHealth3'" />
                  <!-- Money Health 3 -->
                  <Q6 :QuestionType="'MoneyHealth4'" />
                  <!-- Money Health 4 -->
                  <Q7 :QuestionType="'MoneyHealth5'" />
                  <!-- Money Health 5 -->
                  <Q8 :QuestionType="'MoneyHealth6'" />
                  <!-- Money Health 6 -->
                  <!-- Check Step2-Q10 -->
                  <Q9 :QuestionType="'MoneyHealth7'" />
                  <!-- Money Health 7 -->
                  <!-- Check Step2-Q10 -->
                  <Q10 :QuestionType="'MoneyHealth8'" />
                  <!-- Money Health 8 -->
                </div>
              </div>
            </div>
          </div>
          <div class="section-fieldset-button"></div>
        </div>
      </form>
      <div id="popup-input" class="mfp-hide modal-input">
        <div class="modal-content">
          <div class="tb">
            <div class="tbcell v-middle">
              <form class="icw-form">
                <fieldset>
                  <div>
                    <h3 class="heading-h3">อื่นๆ</h3>
                  </div>
                  <div class="icw-fieldset-inner">
                    <ul class="icw-fields">
                      <li class="icw-field icw-field-full">
                        <div class="icw-input a-left">
                          <input
                            type="text"
                            name=""
                            id=""
                            placeholder="โปรดระบุ"
                          />
                        </div>
                      </li>
                      <li class="icw-field icw-field-full">
                        <div class="icw-input a-center">
                          <button type="button" class="btn btn-th">ตกลง</button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import jQuery from "jquery";

import MyConfig from "@/../me.config.js";

import { getCurrentStep, my_range } from "@/helpers/global_helper.js";

import Header from "@/components/Header.vue";

import Q1 from "@/components/QuestionStep2/STEP2-Q1.vue";
import Q2 from "@/components/QuestionStep2/STEP2-Q2.vue";
import Q3 from "@/components/QuestionStep2/STEP2-Q3.vue";
import Q4 from "@/components/QuestionStep2/STEP2-Q4.vue";
import Q5 from "@/components/QuestionStep2/STEP2-Q5.vue";
import Q6 from "@/components/QuestionStep2/STEP2-Q6.vue";
import Q7 from "@/components/QuestionStep2/STEP2-Q7.vue";
import Q8 from "@/components/QuestionStep2/STEP2-Q8.vue";
import Q9 from "@/components/QuestionStep2/STEP2-Q9.vue";
import Q10 from "@/components/QuestionStep2/STEP2-Q10.vue";
window.jQuery = window.$ = jQuery;

require("@/assets/theme/js/library/jquery.easing.1.3.min.js");
require("@/assets/theme/plugin/magnific-popup/jquery.magnific-popup.js");

require("@/assets/theme/plugin/bootstrap/bootstrap.min.js");

Vue.mixin({
  data: function() {
    return {
      isError: false,
      wrongFormat: false,
      save_types: [],
      is_stanby: false,
      is_save_retire: false,
      is_legacy: false,
      disableSaveRetire: false
    };
  },
  methods: {
    MoneyManageType() {
      return [
        {
          key: "child",
          name: "วางแผนอนาคตให้ลูกรัก<small class=\"txt\">Education Fund</small>"
        },
        {
          key: "changevat",
          name: "เปลี่ยนภาษีเป็นเงินออม<small class=\"txt\">Tax Planning</small>"
        },
        {
          key: "save_retire",
          name: "อุ่นใจ วัยเกษียณ<small class=\"txt\">Retirement Plan</small>"
        },
        {
          key: "legacy",
          name:
            "วางแผนมรดก ส่งต่อความมั่งคั่ง<small class=\"txt\">Legacy Plan</small>"
        },
        {
          key: "inc_saving",
          name:
            "เพิ่มเงินออม เพิ่มทางเลือกลงทุน<small class=\"txt\">Save & Invest</small>"
        },
        {
          key: "stanby",
          name: "หลักประกันครอบครัว<small class=\"txt\">Family Wealth</small>"
        }
      ];
    }
  }
});

export default {
  name: "Step2",
  mounted() {
    this.$nextTick(() => {
      require("@/assets/theme/js/theme.js");
    });
    if (!sessionStorage.getItem("Information")) {
      window.location.href = MyConfig.InfoPath;
    }
  },
  components: {
    Header,
    Q1,
    Q2,
    Q3,
    Q4,
    Q5,
    Q6,
    Q7,
    Q8,
    Q9,
    Q10
  },
  data() {
    return {
      currentStep: getCurrentStep("step2"),
      ProgressLength: my_range(1, 10),
      info: MyConfig.InfoPath,
      wealth: MyConfig.WealthPath,
      health: MyConfig.HealthPath
    };
  },
  methods: {
    GoTo(step) {
      return this.$router.push(step);
    }
  },
  watch: {
    currentStep: function(n, o) {
      this.ProgressLength = my_range(1, 10);
    }
  }
};
</script>
